import { DialogStateManager } from '@plato/ui-legacy/components/dialog/dialog-provider';
import { DropdownMenuItem } from '@plato/ui/containers/dropdown-menu';
import { MenuItemLabel, MenuItemLeading } from '@plato/ui/primitives/menu';
import { ClipboardCheckIcon } from 'lucide-react';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import type { CustomerDTO } from '../../../server/dto/customer-dto.ts';
import { Can } from '../../acl/can.tsx';
import { LogInteractionDialog, type LogInteractionDialogProps } from './log-interaction-dialog.tsx';

export type DropdownMenuItemCreateNoteProps = {
    customer?: CustomerDTO;
    onSuccess?: () => void;
    analyticsSource?: LogInteractionDialogProps['analyticsSource'];
};

export function DropdownMenuItemCreateNote({
    customer,
    onSuccess,
    analyticsSource,
}: DropdownMenuItemCreateNoteProps): ReactNode {
    const { t } = useTranslation();

    return (
        <Can I="create" a="Note">
            <DropdownMenuItem
                onClick={() => {
                    void DialogStateManager.show(LogInteractionDialog, {
                        customer,
                        onSuccess,
                        analyticsSource,
                    });
                }}
            >
                <MenuItemLeading>
                    <ClipboardCheckIcon />
                </MenuItemLeading>
                <MenuItemLabel>{t('top_navbar__new_note')}</MenuItemLabel>
            </DropdownMenuItem>
        </Can>
    );
}
